import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Loader from '../../../components/UI/Loader.js';

import animationData from '../../../assets/loader.json'; // Adjust the path as needed
import Lottie from "react-lottie";
import {CleanUrl} from "../../../utils/cleanUrl";

export default function PotatoHuntStepVideo(props) {
	const {promotionSettings, onNextStep} = props;
	const {t} = useTranslation();
	const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);
	const videoRef = useRef(null);
	const [isLoading, setIsLoading] = useState(true);
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};


	function handleSkipVideo() {
		// Pause video
		videoRef.current.pause();

		// Go to next step
		onNextStep();
	}

	function handleVideoEnd() {
		// Go to next step
		onNextStep();
	}


	return (
		<div className="potato-hunt-sub-component potato-hunt-video-component">

			<div className="potato-hunt-sub-component--inner ">
				{isLoading ? <div className="video-loader">
					<Lottie options={defaultOptions}/>
				</div> : <></>}

				<video poster={imagePath + "potato-hunt/" + 'transparetnt-video-poster.png'}
					   preload={"auto"} ref={videoRef} autoPlay muted playsInline onEnded={handleVideoEnd}
					   src={promotionSettings.promotion_type.intro_video}
					   type="video/mp4"
					   onCanPlayThrough={() => {
						   setIsLoading(false);
					   }}
				></video>


				<div className="potato-hunt-video__action">
					<button type="button" className="skip-video-btn"
							onClick={handleSkipVideo}>{t('Skip video')}</button>
				</div>

			</div>
		</div>
	)
}
